/* eslint-disable import/no-cycle */
import { put, takeLatest, takeEvery } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { notificationAction } from "redux/slice/notifications";
import { getAllUnseenBadges, setBadgesAsSeen } from "apis/notifications";

export function* checkUnseenBadges(action) {
  let errorMsg = "";
  try {
    const content = yield getAllUnseenBadges(action.payload);

    if (content.data?.success) {
      if (content.data.data?.length) {
        yield put(notificationAction.showNotification({ awardedBadges: content.data.data }));
      }
    } else if (content.response?.status !== 403) {
      errorMsg = content.response?.data?.message || "Something went wrong";
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
    yield put(notificationAction.checkUnseenBadgesFinished());
  }
}

export function* setBadgesSeen(action) {
  let errorMsg = "";
  try {
    const awardedBadges = action.payload;
    if (awardedBadges.length) {
      const response = yield setBadgesAsSeen(awardedBadges.map((badge) => badge.id));

      if (!response.data?.success) {
        errorMsg = response.response?.data?.message || "Unable to mark badges as seen";
      }
    }
  } catch (error) {
    errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
  } finally {
    if (errorMsg) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: errorMsg,
        }),
        {
          variant: "custom",
        }
      );
    }
  }
}

export function* watchNotificationsAsync() {
  yield takeLatest(notificationAction.checkUnseenBadgesAction, checkUnseenBadges);
  yield takeEvery(notificationAction.closeNotification, setBadgesSeen);
}
